BoardsSidebarSectionView = require 'views/boards-sidebar/boards-sidebar-section-view'
Browser = require 'lib/browser'
DragSort = require 'views/lib/drag-sort'
l = require 'lib/localize'

module.exports = class BoardsSidebarStarredSectionView extends BoardsSidebarSectionView
  initialize: ->
    super

    @listenTo @model.boardStarList, 'add remove reset change:pos', ->
      @debouncedRenderBoards()

  getBoards: ->
    @model.boardStarList.getBoards()

  showOrgName: -> true

  sectionId: -> "starred-boards"

  sectionName: -> "Starred Boards"

  getHeaderInfo: ->
    {
      title: l('board section title.starred boards')
      iconClass: 'star'
    }

  postRenderBoardsEvent: ->
    if !Browser.isTouch()
      $list = @$('.js-board-list')

      if @initedSortable
        DragSort.refreshIfInitialized $list

      else
        @initedSortable = true

        $list.sortable
          axis: 'y'
          containment: 'parent'
          delay: 75
          distance: 7
          forcePlaceholderSize: true
          items: '> li'
          placeholder: 'placeholder'
          scroll: true
          # If we don't use a clone element, FF will trigger a click when we
          # drop the element
          # See http://forum.jquery.com/topic/jquery-ui-sortable-triggers-a-click-in-firefox-15
          # and https://bugzilla.mozilla.org/show_bug.cgi?id=787944
          helper: 'clone'

          stop: (e, ui) =>
            @defer => ui.item.trigger("moveto", ui)
            return

          tolerance: 'pointer'



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-starred-section-view.coffee